module.exports = __webpack_public_path__ + "img/203.d81b1f0a.jpg";